import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { CustomHttpErrorHandlerService } from '@abp/ng.theme.shared';
import { CUSTOM_HTTP_ERROR_HANDLER_PRIORITY } from '@abp/ng.theme.shared';
import { ToasterService } from '@abp/ng.theme.shared';
import { Subject } from 'rxjs';
import { ICrudBulkOperationError } from '../interfaces/ICrudError';

@Injectable({
  providedIn: 'root',
})
export class ZnErrorHandler implements CustomHttpErrorHandlerService {
  readonly priority = CUSTOM_HTTP_ERROR_HANDLER_PRIORITY.veryHigh;
  protected readonly toaster = inject(ToasterService);
  private error: HttpErrorResponse | undefined = undefined;

  private errorSubject = new Subject<ICrudBulkOperationError>();
  errorData$ = this.errorSubject.asObservable();

  // What kind of error should be handled by this service? You can decide it in this method. If error is suitable to your case then return true; otherwise return false.
  canHandle(error: unknown): boolean {
    if (error instanceof HttpErrorResponse && error.status === 400) {
      this.error = error;
      return true;
    }
    if (error instanceof HttpErrorResponse && error.status === 403) {
      this.error = error;
      return true;
    }
    if (error instanceof HttpErrorResponse && error.status === 409) {
      this.error = error;
      return true;
    }
    if (error instanceof HttpErrorResponse && error.status === 500) {
      this.error = error;
      return true;
    }
    if (error instanceof HttpErrorResponse && error.status === 404) {
      this.error = error;
      return true;
    }
    return false;
  }
  // If this service is picked from ErrorHandler, this execute method will be called.
  execute() {
    const type = this.error.error?.data?.type || '';
    const message = this.error.error?.error?.message;
    const statusCode = this.error.status.toString();
    const failedRecords: any[] = this.error.error?.data?.failedRecords;

    if (failedRecords && failedRecords.length) {
      this.errorSubject.next({
        statusCode: statusCode,
        failedRecords: failedRecords,
      });
    }

    switch (type) {
      case 'warn':
        this.toaster.warn(message);
        break;
      case 'info':
        this.toaster.info(message);
        break;
      default:
        this.toaster.error(message);
        break;
    }
  }
}
